export default "/fonts/parisienne-regular-webfont.eot?1260b7839f6fb2b3b399a56146b05bb1";